import { type ReactNode } from "react";

import { cn } from "@/lib/utils";
import { sanitizeUrl } from "@/utils";

const URL_PATTERN = /https?:\/\/[^\s<>"']+/g;
const TRAILING_PUNCTUATION = /[.,;:!?،؛)\]»]+$/;

export default function NotificationContent({
  content,
  className,
}: {
  content: string;
  className?: string;
}) {
  const nodes: ReactNode[] = [];
  let lastIndex = 0;

  for (const match of content.matchAll(URL_PATTERN)) {
    const start = match.index;
    if (start > lastIndex) {
      nodes.push(content.slice(lastIndex, start));
    }

    let url = match[0];
    let trailing = "";
    const punctuation = url.match(TRAILING_PUNCTUATION);
    if (punctuation && punctuation[0].length < url.length) {
      trailing = punctuation[0];
      url = url.slice(0, -trailing.length);
    }

    nodes.push(
      <a
        key={start}
        href={sanitizeUrl(url)}
        target="_blank"
        rel="noopener noreferrer"
        dir="ltr"
        className="en-number text-primary-600 underline"
      >
        {url}
      </a>,
    );
    if (trailing) {
      nodes.push(trailing);
    }
    lastIndex = start + match[0].length;
  }

  if (lastIndex < content.length) {
    nodes.push(content.slice(lastIndex));
  }

  return (
    <div className={cn("wrap-anywhere whitespace-pre-line", className)}>
      {nodes}
    </div>
  );
}
